import { Availability } from '../domain/Availability.model';
import React from 'react';
import { useTenantContext } from '../../tenant/TenantContext'; // Asegúrate que la ruta sea correcta

interface Props {
    data: {
        availability: Availability;
    };
}

export const AvailabilityUI = ({ data }: Props) => {
    const { availability } = data;
    const { primaryColor } = useTenantContext();

    if (!availability) return null;

    return (
        <small style={{ color: availability.isAvailable ? primaryColor : "#000" }}>
            {availability.msg}
        </small>
    );
};
